import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'the_fac_does_not_set_targets_key_performance_indicators'

export const dataPointDefinition = {
  retracedId: 'the_fac_does_not_set_targets_key_performance_indicators',
  name: 'The facility does not set targets / key performance indicators',
  meta: {},
  fieldTypeId: 'BOOLEAN',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'boolean',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-3-18x',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 21040,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
